module.exports = __webpack_public_path__ + "img/link-pocket-mobile_cn.fe9a006.jpg";